<template>
    <b-modal
        centered
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        v-model="form.show"
    >
        <template #modal-header="{}">
            <div class="header flex-grow-1 text-center">
                <h2 class="font-weight-bold">{{ form.categoryCar.id ? 'แก้ไข' : 'เพิ่ม' }}ประเภทรถ</h2>
            </div>
            <span class="close cursor-pointer" @click="form.show = false">&times;</span>
        </template>
        <ValidationObserver ref="observer">
            <b-form @submit="onSubmit">
                <card shadow type="secondary" class="m--4">
                    <b-row>
                        <b-col cols="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="ชื่อประเภทรถ">
                                    <b-form-input
                                        placeholder="ชื่อประเภทรถ"
                                        v-model="form.categoryCar.name"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="ประเภทอุณหภูมิ">
                                    <b-form-input
                                        placeholder="ประเภทอุณหภูมิ"
                                        v-model="form.categoryCar.typeTemperature"
                                        :state="!errors.length ? null : false"
                                    />
                                </b-form-group>
                                <b-form-invalid-feedback>
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        
                        <b-col cols="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="อุณหภูมิ">
                                    <b-form-input
                                        placeholder="อุณหภูมิ"
                                        v-model="form.categoryCar.temperature"
                                        :state="!errors.length ? null : false"
                                    />
                                </b-form-group>
                                <b-form-invalid-feedback>
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <template slot="footer">
                        <b-row class="justify-content-between">
                            <b-col cols="4">
                                <b-button
                                    block
                                    @click="closeModalConfirm()"
                                >
                                    ยกเลิก
                                </b-button>
                            </b-col>
                            <b-col cols="6">
                                <b-button 
                                    type="submit" 
                                    variant="primary"
                                    block
                                    :disabled="form.isLoad"
                                >
                                    <i class="fas fa-circle-notch fa-spin" v-if="form.isLoad"></i> 
                                    ยืนยัน
                                </b-button>
                            </b-col>
                        </b-row>
                    </template>
                </card>
            </b-form>
        </ValidationObserver>
    </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { modalSuccess, modalError } from '@/util/alert.js'
import categoryCarServices from "@/api/category-car.service.js";

export default {
    props: {
        form: {
            type: Object
        }
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return { 
            
        }
    },
    async mounted(){
        if(this.form.categoryCar.id){
            await this.getCategoryCarById();
        }
    },
    methods: {
        async onSubmit(event) {
            event.preventDefault();
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }
            const payload = {
                name: this.form.categoryCar.name,
                temperature_type: this.form.categoryCar.typeTemperature,
                degrees: this.form.categoryCar.temperature,
            }

            try {
                if(this.form.categoryCar.id){
                    payload.vehicle_category_id = this.form.categoryCar.id

                    const response = await categoryCarServices.updateCategoryCar(payload);
                }else{
                    const response = await categoryCarServices.createCategoryCar(payload);
                }
        
                modalSuccess(this.$bvModal, this.form.categoryCar.id ? 'แก้ไขข้อมูลประเภทรถสำเร็จ' : 'เพิ่มประเภทรถสำเร็จ')
                await this.$emit('getCategoryCar')
                this.closeModalConfirm();
        
            } catch (err) {
                modalError(this.$bvModal, 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
            }

        },
        async getCategoryCarById() {

        },
        closeModalConfirm(){
            this.$refs.observer.reset();
            this.form.show = false
            this.form.isLoad = false
            this.form.categoryCar = {
                name: null,
                typeTemperature: null,
                temperature: null
            }
        }
    }
}
</script>
